import {gsap} from 'gsap';

( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '[data-component="featured-services-tabs"]' ).forEach( ( component ) => {
        const pattern = component.querySelector( '.featured-services-tabs__pattern-motion' );
        const contentAnimations = [...component.querySelectorAll( '.js-fade, .js-fade-group' )]
            .filter( ( element ) => !element.closest( '.splide__slide' ) );

        if ( !pattern ) {
          return;
        }

        if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
          gsap.set( pattern, {autoAlpha: 1, y: 0} );
          return;
        }

        gsap.set( pattern, {autoAlpha: 0, y: -75} );

        const revealPattern = () => {
          const contentIsAnimated = contentAnimations.every( ( element ) => element.classList.contains( 'js-animated' ) );

          if ( !contentIsAnimated ) {
            return;
          }

          mutationObserver.disconnect();
          gsap.to( pattern, {
            autoAlpha: 1,
            y: 0,
            duration: 0.75,
            delay: 1,
            ease: 'power2.out',
            clearProps: 'transform,visibility',
          } );
        };

        const mutationObserver = new MutationObserver( revealPattern );
        contentAnimations.forEach( ( element ) => {
          mutationObserver.observe( element, {attributes: true, attributeFilter: ['class']} );
        } );
        revealPattern();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'featured-services-tabs', COMPONENT );
} )( app );

